<template>
	<MainContent>
		<div class="w-full flex flex-col items-center justify-center">
			<div class="w-full md:w-4/12">
				<div
					v-for="(modality, index) in filteredModalities"
					:key="index"
					class="select-card with-border mb-3"
					:class="{
						active:
							selected.modality &&
							modality.id === selected.modality.id,
						unavailable: modality.is_unavailable,
					}"
					@click="modality.is_unavailable ? null : Select(modality)"
				>
					<label>
						{{ modality.name }}
						<i
							v-if="editable"
							class="fas fa-pen"
							style="margin-right: 2.5rem"
							@click.stop="Edit(modality)"
						></i>
						<i class="far fa-chevron-right"></i>
					</label>
				</div>
			</div>
		</div>

		<div
			class="modal fade"
			id="modal-modality"
		>
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header px-5 py-4">
						<h4 class="font-20 m-0">EDITAR MODALIDADE</h4>
						<button
							type="button"
							class="position-absolute btn btn-light p-3 ps-r-0 ps-t-0 m-3"
							data-dismiss="modal"
						>
							<i class="far fa-times mx-1"></i>
						</button>
					</div>
					<hr class="m-0" />
					<div class="modal-body">
						<div class="form-row p-4 justify-content-center">
							<div class="col-12">
								<div class="form-group">
									<input
										type="text"
										placeholder="Nome"
										v-model="form.name"
										class="form-control"
										disabled
									/>
								</div>
							</div>
							<div
								v-if="editable"
								class="col-12"
							>
								<div class="form-group">
									<label>Instruções de Agendamento</label>
									<Editor v-model="form.instructions" />
								</div>
							</div>
						</div>
						<hr class="m-0" />
						<div class="d-flex justify-content-between p-4">
							<button
								class="btn btn-danger p-3 px-4"
								data-dismiss="modal"
							>
								CANCELAR
							</button>

							<button
								class="btn btn-success p-3 px-4"
								@click="Save()"
							>
								SALVAR
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</MainContent>
</template>

<script>
	const _ = require('lodash')
	import { mapGetters, mapActions } from 'vuex'
	import Editor from './Editor.vue'
	import { useConfirmation, useDeleteAlert, useError } from '@/composables'
	export default {
		name: 'Modalities',
		components: {
			Editor,
		},
		props: {
			label: {
				type: String,
				default: '',
			},
			module_id: {
				type: [String, Number],
				default: null,
			},
			modality_id: {
				type: [String, Number],
				default: null,
			},
			type: {
				type: String,
				default: 'strict', //'all'
			},
			editable: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				selected: {
					modality: null,
				},
				form: {
					id: '',
					name: '',
					instructions: '',
				},
			}
		},
		watch: {
			modality_id: {
				handler(val) {
					if (val) {
						this.selected.modality = this.filteredModalities.find(
							m => m.id === parseInt(val)
						)
					}
				},
				immediate: true,
			},
		},
		computed: {
			...mapGetters('system', ['modalities']),
			...mapGetters('auth', ['requester_selected_id']),
			filteredModalities() {
				return _.sortBy(
					this.modalities.filter(modality => {
						let allowed = true

						if (this.type == 'strict') {
							allowed = false

							if (
								(Array.isArray(modality.schedules) &&
									modality.schedules.length > 0) ||
								modality.schedules_count > 0
							) {
								allowed = true
							}
						}

						return (
							allowed &&
							modality.module_id == parseInt(this.module_id)
						)
					}),
					'name',
					'asc'
				)
			},
		},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			Select(modality) {
				this.$emit('next', modality)
			},
			Previous() {
				this.$emit('previous')
			},
			Edit(modality) {
				this.form.id = modality.id
				this.form.name = modality.name
				this.form.instructions = modality.instructions

				window.jQuery('#modal-modality').modal('show')
			},
			Save() {
				this.StartLoading()

				return window.api
					.call('post', '/save-modules-and-modalities-instructions', {
						organization_id: this.requester_selected_id,
						type: 'modality',
						modality_id: this.form.id,
						instructions: this.form.instructions,
					})
					.then(({ data }) => {
						if (data.response) {
							const idx = this.modalities.findIndex(
								m => m.id === this.form.id
							)
							if (idx !== -1) {
								this.modalities[idx].instructions =
									this.form.instructions
							}

							useConfirmation()
						} else {
							useError(
								'Houve um erro ao concluir, contate o suporte.'
							)
						}
					})
					.finally(() => {
						window.jQuery('.modal').modal('hide')
						this.FinishLoading()
					})
			},
		},
		mounted() {
			if (
				this.filteredModalities.length === 1 &&
				!this.selected.modality
			) {
				this.Select(this.filteredModalities[0])
			}
		},
	}
</script>

<style lang="css" scoped>
	.select-card.unavailable {
		cursor: not-allowed;
	}
	.select-card.unavailable:hover label {
		background-color: firebrick;
		border-color: firebrick !important;
	}

	.select-card.unavailable:hover i {
		color: firebrick !important;
	}

	.modal-dialog {
		max-width: 90%;
	}
</style>
